<!-- @veltra/icons generated sha256:397f8583cae986b0 gen:8 source:src/svg/normal/queue.svg -->
<script setup lang="ts">
defineOptions({ name: 'Queue' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M4.496 3H13v8.504a.5.5 0 0 0 1 0V3a1 1 0 0 0-1-1H4.496a.5.5 0 0 0 0 1M2 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1zm1-8h8v8H3zm3.583 6.836v-2.42H4.164a.5.5 0 0 1 0-1h2.42V6.16c0-.276.227-.493.496-.493.276 0 .503.217.503.493v2.257H9.84c.276 0 .493.227.493.496a.497.497 0 0 1-.493.504H7.583v2.419a.485.485 0 0 1-.485.497h-.011a.5.5 0 0 1-.504-.497"
    />
  </svg>
</template>
